import AsyncStorage from "@react-native-community/async-storage";
import React from "react";

export type Language = "en" | "es" | "fr";
const STORAGE_KEY = "bodyart.customer.language";

type Dictionary = Record<string, string>;
const es: Dictionary = {
  "Secure digital consent": "Consentimiento digital seguro",
  "Your visit starts here": "Tu visita comienza aqu\u00ed",
  "Complete your shop paperwork from your phone before your procedure.":
    "Completa los formularios del estudio desde tu tel\u00e9fono antes del procedimiento.",
  "About 5-8 minutes": "Aproximadamente 5-8 minutos",
  "Have your photo ID ready": "Ten lista tu identificaci\u00f3n con foto",
  "Start at House of Tattoo": "Comenzar en House of Tattoo",
  "I have a shop link": "Tengo un enlace del estudio",
  "Enter shop link": "Ingresar enlace del estudio",
  "Hide shop link": "Ocultar enlace del estudio",
  "Paste your shop link or code": "Pega el enlace o c\u00f3digo del estudio",
  "Continue to shop": "Continuar al estudio",
  "Enter the shop link or code provided by the shop.":
    "Ingresa el enlace o c\u00f3digo proporcionado por el estudio.",
  "Using a shop QR code? Scan it with your phone camera and this page will open at the correct shop automatically.":
    "Tienes un c\u00f3digo QR del estudio? Escanealo con la camara de tu tel\u00e9fono y esta p\u00e1gina abrir\u00e1 autom\u00e1ticamente el estudio correcto.",
  "What to expect": "Qu\u00e9 esperar",
  "Your information": "Tu informaci\u00f3n",
  "Confirm your details and photo ID.":
    "Confirma tus datos y tu identificaci\u00f3n con foto.",
  "Choose services": "Elige servicios",
  "Tell the shop what you are visiting for.":
    "Indica al estudio el motivo de tu visita.",
  "Health and consent": "Salud y consentimiento",
  "Answer only the questions that apply.":
    "Responde solo las preguntas que correspondan.",
  "Review and sign": "Revisar y firmar",
  "Check everything before submitting.": "Revisa todo antes de enviarlo.",
  "Returning customer?": "Ya eres cliente?",
  "Use the new link from your shop and the same email address. We will reuse eligible profile information so you do not have to start over.":
    "Usa el nuevo enlace de tu estudio y la misma direcci\u00f3n de correo. Reutilizaremos la informaci\u00f3n de perfil disponible para que no tengas que comenzar de nuevo.",
  "Your information is securely shared only with the shop handling your visit.":
    "Tu informaci\u00f3n se comparte de forma segura solo con el estudio que atiende tu visita.",
  Privacy: "Privacidad",
  Terms: "Terminos",
  "Basic Info": "Informaci\u00f3n b\u00e1sica",
  Login: "Iniciar sesi\u00f3n",
  "Forgot Password": "Olvide mi contrase\u00f1a",
  "Get Started": "Comenzar",
  "Your Info": "Tus datos",
  Edit: "Editar",
  "Minor's Basic Info": "Informaci\u00f3n b\u00e1sica del menor",
  "Visit Details": "Detalles de la visita",
  "Medical History": "Historial m\u00e9dico",
  Consent: "Consentimiento",
  Review: "Revisar",
  Signature: "Firma",
  Continue: "Continuar",
  Back: "Atras",
  Cancel: "Cancelar",
  Save: "Guardar",
  Submit: "Enviar",
  Done: "Listo",
  Next: "Siguiente",
  "Email Address": "Correo electronico",
  Password: "Contrasena",
  "First Name": "Nombre",
  "Last Name": "Apellido",
  "Phone Number": "N\u00famero de tel\u00e9fono",
  "Date of Birth": "Fecha de nacimiento",
  Address: "Direcci\u00f3n",
  City: "Ciudad",
  State: "Estado",
  "Zip Code": "C\u00f3digo postal",
  "Select services": "Seleccionar servicios",
  "Add another service": "Agregar otro servicio",
  "Begin paperwork": "Comenzar formularios",
  "Continue paperwork": "Continuar formularios",
  "View details": "Ver detalles",
  "Call shop": "Llamar al estudio",
  Directions: "Como llegar",
  Upcoming: "Pr\u00f3ximas",
  Previous: "Anteriores",
  Profile: "Perfil",
  "New Visit": "Nueva visita",
  "No upcoming visits": "No hay visitas pr\u00f3xim\u00e1s",
  "Ready for your next appointment?": "Listo para tu pr\u00f3xima cita?",
  "Start New Visit": "Iniciar nueva visita",
  "No previous visits yet.": "A\u00fan no hay visitas anteriores.",
  "Load 20 more": "Cargar 20 m\u00e1s",
  "Your paperwork": "Tus formularios",
  Details: "Datos",
  Services: "Servicios",
  Sign: "Firmar",
  "Service details pending": "Detalles del servicio pendientes",
  "Artist not assigned": "Artista no asignado",
  "Your information has been submitted!":
    "Tu informaci\u00f3n ha sido enviada!",
  "We're excited to see you. Remember to bring a form of ID with you to your appointment.":
    "Nos alegra verte pronto. Recuerda llevar una identificaci\u00f3n a tu cita.",
  "You will receive email updates about your visit.":
    "Recibir\u00e1s actualizaciones por correo sobre tu visita.",
  "No visits allowed right now": "No se permiten visitas en este momento",
  "We're sorry but at the current time this store is not available for a new procedure. Please speak to the staff at the store.":
    "Lo sentimos, este estudio no esta disponible para un nuevo procedimiento en este momento. Habla con el personal del estudio.",
};
const fr: Dictionary = {
  "Secure digital consent": "Consentement num\u00e9rique s\u00e9curis\u00e9",
  "Your visit starts here": "Votre visite commence ici",
  "Complete your shop paperwork from your phone before your procedure.":
    "Remplissez les formulaires du studio sur votre t\u00e9l\u00e9phone avant votre intervention.",
  "About 5-8 minutes": "Environ 5 \u00e0 8 minutes",
  "Have your photo ID ready":
    "Gardez votre pi\u00e8ce d'identit\u00e9 avec photo a portee de main",
  "Start at House of Tattoo": "Commencer chez House of Tattoo",
  "I have a shop link": "J'ai un lien du studio",
  "Enter shop link": "Saisir le lien du studio",
  "Hide shop link": "Masquer le lien du studio",
  "Paste your shop link or code": "Collez le lien ou le code du studio",
  "Continue to shop": "Continuer vers le studio",
  "Enter the shop link or code provided by the shop.":
    "Saisissez le lien ou le code fourni par le studio.",
  "Using a shop QR code? Scan it with your phone camera and this page will open at the correct shop automatically.":
    "Vous utilisez un code QR du studio? Scannez-le avec l'appareil photo de votre t\u00e9l\u00e9phone et cette page ouvrira automatiquement le bon studio.",
  "What to expect": "A quoi s'attendre",
  "Your information": "Vos informations",
  "Confirm your details and photo ID.":
    "Confirmez vos coordonn\u00e9es et votre pi\u00e8ce d'identit\u00e9.",
  "Choose services": "Choisissez les services",
  "Tell the shop what you are visiting for.":
    "Indiquez au studio le motif de votre visite.",
  "Health and consent": "Sante et consentement",
  "Answer only the questions that apply.":
    "R\u00e9pondez uniquement aux questions qui vous concernent.",
  "Review and sign": "Verifier et signer",
  "Check everything before submitting.": "V\u00e9rifiez tout avant l'envoi.",
  "Returning customer?": "D\u00e9j\u00e0 client?",
  "Use the new link from your shop and the same email address. We will reuse eligible profile information so you do not have to start over.":
    "Utilisez le nouveau lien de votre studio et la meme adresse courriel. Nous r\u00e9utiliserons les informations de profil admissibles.",
  "Your information is securely shared only with the shop handling your visit.":
    "Vos informations sont partagees en toute securite uniquement avec le studio qui gere votre visite.",
  Privacy: "Confidentialite",
  Terms: "Conditions",
  "Basic Info": "Informations de base",
  Login: "Connexion",
  "Forgot Password": "Mot de passe oubli\u00e9",
  "Get Started": "Commencer",
  "Your Info": "Vos informations",
  Edit: "Modifier",
  "Minor's Basic Info": "Informations du mineur",
  "Visit Details": "D\u00e9tails de la visite",
  "Medical History": "Ant\u00e9c\u00e9dents m\u00e9dicaux",
  Consent: "Consentement",
  Review: "V\u00e9rification",
  Signature: "Signature",
  Continue: "Continuer",
  Back: "Retour",
  Cancel: "Annuler",
  Save: "Enregistrer",
  Submit: "Envoyer",
  Done: "Termine",
  Next: "Suivant",
  "Email Address": "Adresse courriel",
  Password: "Mot de passe",
  "First Name": "Pr\u00e9nom",
  "Last Name": "Nom",
  "Phone Number": "N\u00famero de t\u00e9l\u00e9phone",
  "Date of Birth": "Date de naissance",
  Address: "Adresse",
  City: "Ville",
  State: "Etat ou province",
  "Zip Code": "Code postal",
  "Select services": "S\u00e9lectionner les services",
  "Add another service": "Ajouter un autre service",
  "Begin paperwork": "Commencer les formulaires",
  "Continue paperwork": "Continuer les formulaires",
  "View details": "Voir les details",
  "Call shop": "Appeler le studio",
  Directions: "Itineraire",
  Upcoming: "A venir",
  Previous: "Pr\u00e9c\u00e9dentes",
  Profile: "Profil",
  "New Visit": "Nouvelle visite",
  "No upcoming visits": "Aucune visite \u00e0 venir",
  "Ready for your next appointment?":
    "Pr\u00eat pour votre prochain rendez-vous?",
  "Start New Visit": "Commencer une nouvelle visite",
  "No previous visits yet.": "Aucune visite pr\u00e9c\u00e9dente.",
  "Load 20 more": "Charger 20 de plus",
  "Your paperwork": "Vos formulaires",
  Details: "Coordonnees",
  Services: "Services",
  Sign: "Signer",
  "Service details pending": "D\u00e9tails du service en attente",
  "Artist not assigned": "Artiste non assign\u00e9",
  "Your information has been submitted!":
    "Vos informations ont \u00e9t\u00e9 envoy\u00e9es!",
  "We're excited to see you. Remember to bring a form of ID with you to your appointment.":
    "Nous avons h\u00e2te de vous voir. Pensez a apporter une pi\u00e8ce d'identit\u00e9 a votre rendez-vous.",
  "You will receive email updates about your visit.":
    "Vous recevrez des mises a jour par courriel concernant votre visite.",
  "No visits allowed right now": "Aucune visite permise pour le moment",
  "We're sorry but at the current time this store is not available for a new procedure. Please speak to the staff at the store.":
    "Nous sommes d\u00e9sol\u00e9s, ce studio n'est pas disponible pour une nouvelle intervention actuellement. Veuillez parler au personnel du studio.",
};

Object.assign(es, {
  "Who's getting the procedure?": "Quien recibira el procedimiento?",
  Myself: "Yo",
  "A new minor": "Un nuevo menor",
  Unknown: "Desconocido",
  "Sorry, you're not allowed to do that": "Lo sentimos, no puedes hacer eso",
  "We're sorry but minors aren't allowed to schedule visits. Please speak to your parent or guardian":
    "Lo sentimos, los menores no pueden programar visitas. Habla con tu padre, madre o tutor.",
  "Go back": "Regresar",
  "To have a service performed we need to know your date of birth. This will be verified against your ID.":
    "Para realizar un servicio necesitamos tu fecha de nacimiento. La verificaremos con tu identificacion.",
  "Please check to make sure all the information listed for you is correct and not out of date.":
    "Comprueba que toda tu informacion sea correcta y este actualizada.",
  "Minor Info": "Datos del menor",
  "ID Uploaded": "Identificacion cargada",
  "ID Verification": "Verificacion de identidad",
  Skip: "Omitir",
  Name: "Nombre",
  "First name": "Nombre",
  "Last name": "Apellido",
  "Street Address Line 1": "Direccion, linea 1",
  "Street Address Line 2": "Direccion, linea 2",
  "Zip code": "Codigo postal",
  "Phone number": "Numero de telefono",
  "The Procedure": "El procedimiento",
  "Review Procedures": "Revisar procedimientos",
  "Add a procedure": "Agregar un procedimiento",
  "Save Changes": "Guardar cambios",
  "Next: Health": "Siguiente: Salud",
  Yes: "Si",
  No: "No",
  "Next: Review": "Siguiente: Revisar",
  "Check to make sure everything looks right.":
    "Comprueba que todo este correcto.",
  "Procedure Details": "Detalles del procedimiento",
  "Health Info": "Informacion de salud",
  "Next: Sign & Submit": "Siguiente: Firmar y enviar",
  "Final step": "Paso final",
  Clear: "Borrar",
  "Sign and submit visit": "Firmar y enviar la visita",
  "Powered By": "Desarrollado por",
  "Log out": "Cerrar sesion",
  "Log in with Email": "Iniciar sesion con correo",
  "Sign up with Email": "Registrarse con correo",
  "Email address": "Correo electronico",
  "We sent a code to your email address. Please input it here to continue.":
    "Enviamos un codigo a tu correo electronico. Ingresalo aqui para continuar.",
  Code: "Codigo",
  Required: "Obligatorio",
  "This field is required": "Este campo es obligatorio",
  "Please answer this question": "Responde esta pregunta",
  "All Done?": "Todo listo?",
});
Object.assign(fr, {
  "Who's getting the procedure?": "Qui recevra l'intervention?",
  Myself: "Moi",
  "A new minor": "Un nouveau mineur",
  Unknown: "Inconnu",
  "Sorry, you're not allowed to do that":
    "Desole, vous ne pouvez pas faire cela",
  "We're sorry but minors aren't allowed to schedule visits. Please speak to your parent or guardian":
    "Nous sommes desoles, les mineurs ne peuvent pas planifier de visite. Veuillez parler a votre parent ou tuteur.",
  "Go back": "Retour",
  "To have a service performed we need to know your date of birth. This will be verified against your ID.":
    "Pour effectuer un service, nous avons besoin de votre date de naissance. Elle sera verifiee avec votre piece d'identite.",
  "Please check to make sure all the information listed for you is correct and not out of date.":
    "Verifiez que toutes vos informations sont exactes et a jour.",
  "Minor Info": "Informations du mineur",
  "ID Uploaded": "Piece d'identite televersee",
  "ID Verification": "Verification de l'identite",
  Skip: "Passer",
  Name: "Nom",
  "First name": "Prenom",
  "Last name": "Nom",
  "Street Address Line 1": "Adresse, ligne 1",
  "Street Address Line 2": "Adresse, ligne 2",
  "Zip code": "Code postal",
  "Phone number": "Numero de telephone",
  "The Procedure": "L'intervention",
  "Review Procedures": "Verifier les interventions",
  "Add a procedure": "Ajouter une intervention",
  "Save Changes": "Enregistrer les modifications",
  "Next: Health": "Suivant : Sante",
  Yes: "Oui",
  No: "Non",
  "Next: Review": "Suivant : Verification",
  "Check to make sure everything looks right.":
    "Verifiez que tout est correct.",
  "Procedure Details": "Details de l'intervention",
  "Health Info": "Informations de sante",
  "Next: Sign & Submit": "Suivant : Signer et envoyer",
  "Final step": "Derniere etape",
  Clear: "Effacer",
  "Sign and submit visit": "Signer et envoyer la visite",
  "Powered By": "Propulse par",
  "Log out": "Deconnexion",
  "Log in with Email": "Connexion par courriel",
  "Sign up with Email": "Inscription par courriel",
  "Email address": "Adresse courriel",
  "We sent a code to your email address. Please input it here to continue.":
    "Nous avons envoye un code a votre adresse courriel. Saisissez-le ici pour continuer.",
  Code: "Code",
  Required: "Obligatoire",
  "This field is required": "Ce champ est obligatoire",
  "Please answer this question": "Veuillez repondre a cette question",
  "All Done?": "Tout est termine?",
});

Object.assign(es, {
  "Medical Concerns": "Problemas medicos",
  "Select any conditions listed below that apply to the minor who will be having this procedure.":
    "Selecciona las condiciones que correspondan al menor que recibira este procedimiento.",
  "Select any conditions listed below that apply to you.":
    "Selecciona las condiciones que correspondan.",
  "Indicate any medical concerns that apply to the minor.":
    "Indica cualquier problema medico que corresponda al menor.",
  "Indicate any medical concerns that apply to you.":
    "Indica cualquier problema medico que te corresponda.",
  None: "Ninguna",
  "Any other medical conditions or notes? (optional)":
    "Alguna otra condicion medica o nota? (opcional)",
  "Do you believe you are healthy enough to receive and successfully heal body art such as piercing, tattooing or permanent makeup?":
    "Crees que estas lo suficientemente saludable para recibir y sanar exitosamente arte corporal como perforaciones, tatuajes o maquillaje permanente?",
  "Do you have a history of skin conditions?":
    "Tienes antecedentes de condiciones de la piel?",
  "Do you use any medications that might affect the healing of your body art?":
    "Usas algun medicamento que pudiera afectar la sanacion de tu arte corporal?",
  "Do you have sensitivities or allergies to soaps, cosmetics, antiseptics, natural rubber latex, or metals of any kind?":
    "Tienes sensibilidades o alergias a jabones, cosmeticos, antisepticos, latex de caucho natural o algun tipo de metal?",
  "Are you prone to fainting, epilepsy, seizures, or narcolepsy?":
    "Eres propenso a desmayos, epilepsia, convulsiones o narcolepsia?",
  "Do you have any medical conditions that might affect the healing of your body art, such as diabetes, high blood pressure, or hemophilia?":
    "Tienes alguna condicion medica que pudiera afectar la sanacion de tu arte corporal, como diabetes, presion arterial alta o hemofilia?",
  "Do you have a history of complications with body art?":
    "Tienes antecedentes de complicaciones con arte corporal?",
  "Yes is required in order to proceed":
    "Se requiere responder Si para continuar",
  "Add your signature": "Agrega tu firma",
  "Use your finger, mouse, or trackpad.": "Usa tu dedo, mouse o panel tactil.",
  "Signing for": "Firmando para",
  "- Visit consent": "- Consentimiento de la visita",
  "Signature added": "Firma agregada",
  "Signature required": "Firma obligatoria",
  "I agree this is my electronic signature.":
    "Acepto que esta es mi firma electronica.",
  "Electronic signature agreement": "Acuerdo de firma electronica",
  "My submitted signature is legally binding like a handwritten signature, and I consent to receive information electronically.":
    "La firma que envio es legalmente vinculante como una firma manuscrita y acepto recibir informacion electronicamente.",
  "Terms of service": "Terminos del servicio",
  "Privacy policy": "Politica de privacidad",
  "Ready to submit securely.": "Listo para enviar de forma segura.",
  "Add a signature and accept the agreement to continue.":
    "Agrega una firma y acepta el acuerdo para continuar.",
  "We could not submit your visit. Please try again.":
    "No pudimos enviar tu visita. Intentalo de nuevo.",
  "The signature upload failed. Please try again.":
    "No se pudo cargar la firma. Intentalo de nuevo.",
  "The signature could not be prepared. Please try again.":
    "No se pudo preparar la firma. Intentalo de nuevo.",
  "Accepted forms of ID include: Driver's license, Passport, Student ID, etc.":
    "Las identificaciones aceptadas incluyen licencia de conducir, pasaporte, identificacion estudiantil, etc.",
  "Select or take picture of a drivers license or any valid ID":
    "Selecciona o toma una foto de una licencia de conducir u otra identificacion valida",
  "* If you skip now, you must show your ID to the shop employee upon arrival for your appointment.":
    "* Si omites este paso, deberas mostrar tu identificacion al personal del estudio cuando llegues a tu cita.",
});
Object.assign(fr, {
  "Medical Concerns": "Problemes medicaux",
  "Select any conditions listed below that apply to the minor who will be having this procedure.":
    "Selectionnez les conditions qui concernent le mineur qui recevra cette intervention.",
  "Select any conditions listed below that apply to you.":
    "Selectionnez les conditions qui vous concernent.",
  "Indicate any medical concerns that apply to the minor.":
    "Indiquez tout probleme medical concernant le mineur.",
  "Indicate any medical concerns that apply to you.":
    "Indiquez tout probleme medical qui vous concerne.",
  None: "Aucune",
  "Any other medical conditions or notes? (optional)":
    "Autres problemes medicaux ou remarques? (facultatif)",
  "Do you believe you are healthy enough to receive and successfully heal body art such as piercing, tattooing or permanent makeup?":
    "Pensez-vous etre en assez bonne sante pour recevoir et cicatriser avec succes un art corporel tel qu'un piercing, un tatouage ou un maquillage permanent?",
  "Do you have a history of skin conditions?":
    "Avez-vous des antecedents de problemes de peau?",
  "Do you use any medications that might affect the healing of your body art?":
    "Prenez-vous des medicaments susceptibles d'affecter la cicatrisation de votre art corporel?",
  "Do you have sensitivities or allergies to soaps, cosmetics, antiseptics, natural rubber latex, or metals of any kind?":
    "Avez-vous des sensibilites ou des allergies aux savons, cosmetiques, antiseptiques, au latex de caoutchouc naturel ou a tout type de metal?",
  "Are you prone to fainting, epilepsy, seizures, or narcolepsy?":
    "Etes-vous sujet aux evanouissements, a l'epilepsie, aux convulsions ou a la narcolepsie?",
  "Do you have any medical conditions that might affect the healing of your body art, such as diabetes, high blood pressure, or hemophilia?":
    "Avez-vous des problemes de sante susceptibles d'affecter la cicatrisation de votre art corporel, comme le diabete, l'hypertension arterielle ou l'hemophilie?",
  "Do you have a history of complications with body art?":
    "Avez-vous des antecedents de complications liees a l'art corporel?",
  "Yes is required in order to proceed":
    "Il est necessaire de repondre Oui pour continuer",
  "Add your signature": "Ajoutez votre signature",
  "Use your finger, mouse, or trackpad.":
    "Utilisez votre doigt, votre souris ou votre pave tactile.",
  "Signing for": "Signature pour",
  "- Visit consent": "- Consentement de la visite",
  "Signature added": "Signature ajoutee",
  "Signature required": "Signature obligatoire",
  "I agree this is my electronic signature.":
    "J'accepte qu'il s'agit de ma signature electronique.",
  "Electronic signature agreement": "Accord de signature electronique",
  "My submitted signature is legally binding like a handwritten signature, and I consent to receive information electronically.":
    "Ma signature soumise est juridiquement contraignante comme une signature manuscrite et j'accepte de recevoir les informations par voie electronique.",
  "Terms of service": "Conditions d'utilisation",
  "Privacy policy": "Politique de confidentialite",
  "Ready to submit securely.": "Pret pour un envoi securise.",
  "Add a signature and accept the agreement to continue.":
    "Ajoutez une signature et acceptez l'accord pour continuer.",
  "We could not submit your visit. Please try again.":
    "Nous n'avons pas pu envoyer votre visite. Veuillez reessayer.",
  "The signature upload failed. Please try again.":
    "Le televersement de la signature a echoue. Veuillez reessayer.",
  "The signature could not be prepared. Please try again.":
    "La signature n'a pas pu etre preparee. Veuillez reessayer.",
  "Accepted forms of ID include: Driver's license, Passport, Student ID, etc.":
    "Les pieces acceptees comprennent le permis de conduire, le passeport, la carte etudiante, etc.",
  "Select or take picture of a drivers license or any valid ID":
    "Selectionnez ou prenez une photo d'un permis de conduire ou d'une piece d'identite valide",
  "* If you skip now, you must show your ID to the shop employee upon arrival for your appointment.":
    "* Si vous passez cette etape, vous devrez montrer votre piece d'identite au personnel du studio a votre arrivee.",
});

const dictionaries: Record<Language, Dictionary> = { en: {}, es, fr };

interface LanguageContextValue {
  language: Language;
  setLanguage: (language: Language) => void;
  t: (value: string) => string;
}
const LanguageContext = React.createContext<LanguageContextValue>({
  language: "en",
  setLanguage: () => undefined,
  t: (value) => value,
});

export const LanguageProvider: React.FC = ({ children }) => {
  const [language, updateLanguage] = React.useState<Language>("en");
  const [isReady, setIsReady] = React.useState(false);
  React.useEffect(() => {
    AsyncStorage.getItem(STORAGE_KEY)
      .then((saved) => {
        if (saved === "en" || saved === "es" || saved === "fr") {
          updateLanguage(saved);
        }
      })
      .finally(() => setIsReady(true));
  }, []);
  const setLanguage = React.useCallback((next: Language) => {
    updateLanguage(next);
    AsyncStorage.setItem(STORAGE_KEY, next);
  }, []);
  const t = React.useCallback(
    (value: string) => {
      const key = value.replace(/\s+/g, " ").trim();
      const direct = dictionaries[language][key];
      if (direct) return direct;
      const age = key.match(/^(\d+) yrs old$/);
      if (age && language === "es") return `${age[1]} anos`;
      if (age && language === "fr") return `${age[1]} ans`;
      const location = key.match(/^(.+) Location$/);
      if (location && language === "es") return `Ubicacion: ${location[1]}`;
      if (location && language === "fr") return `Emplacement : ${location[1]}`;
      return value;
    },
    [language],
  );
  if (!isReady) return null;

  return (
    <LanguageContext.Provider value={{ language, setLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => React.useContext(LanguageContext);
export const translateNode = (
  node: React.ReactNode,
  t: (value: string) => string,
): React.ReactNode => {
  if (typeof node === "string") return t(node);
  if (Array.isArray(node))
    return node.map((child, index) => (
      <React.Fragment key={index}>{translateNode(child, t)}</React.Fragment>
    ));
  return node;
};
